import React from 'react';
import styled from 'styled-components';
import FcLogo  from '../assets/images/logos/FC-Hockey-Logo-White.svg';
import { baseUrl } from '../lib';

const FcLogoContainer = styled.img.attrs(props => ({
    src: props.src
}))`
    cursor: pointer;
    @media(max-width: 900px) {
        width: 122px;
        height: 22px;
    }
`;

const MenuContainer = styled.div`
    height: 100px;
`;

const InnerMenuContainer = styled.div`
    background: #000;
    position: relative;
    height: 100%;
    box-shadow: inset 0 -2px 0 #161718;
`;

const MenuFrame = styled.div`
    position: relative;
    height: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: ${props => props.noPadding ? "0px" : "0px 40px"};
    .inset {
        position: relative;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .inset > ul > li {
        margin: 0 0 0 28px;
        line-height: 42px;
        font-size: 15px;
        font-weight: 700;
        text-transform: uppercase;
        position: relative;
    }
    .inset > ul > li:hover > ul {
        opacity: 1;
        transform: translate(0, 0);
        pointer-events: auto;
    }
    .inset > ul > li:hover > a {
        color: #D6001C;
    }
    @media screen and (max-width: 1180px) {
        .inset > ul > li {margin:0 0 0 15px;font-size: 14px;}
        .inset .b-button {font-size: 14px;height: 32px; line-height: 32px;padding: 0 16px; vertical-align: middle;}
    }
    @media(max-width: 500px){
        padding: 0 15px;
    }
`
const NavItems = styled.ul`
    height: 42px;
    display: flex;
    font-family: 'Roboto Condensed';
    a {
        color: #fff;
        text-decoration: none;
        background-color: transparent;
        transition: color 0.25s;
    }
    li>ul {
        display: block;
        position: absolute;
        overflow: hidden;
        top: 42px;
        left: 0px;
        min-width: 100%;
        opacity: 0;
        transform: translate(0, 40px);
        pointer-events: none;
        transition: opacity 0.25s, transform 0.25s;
        transition-delay: 0.1s;
        border-top: 3px solid #D6001C;
        background: #161718;
        z-index: 1;
    }
    li > ul > li {
        padding: 10px 30px;
        line-height: 20px;
        white-space: nowrap;
        
    }
    li > ul > li:hover > a {
        color: #D6001C;
    }
    li > ul > li:first-child {padding-top:30px;}
    li > ul > li:last-child {padding-bottom:30px;}

    .b-button {
        cursor: pointer;
        max-width: 100%;
        vertical-align: top;
        display: inline-block;
        box-sizing: border-box;
        color: #fff;
        font-family: 'Roboto Condensed', sans-serif;
        text-transform: uppercase;
        font-weight: 700;
        font-size: 16px;
        line-height: 42px;
        height: 42px;
        width: auto;
        padding: 0 21px;
        background: #D6001C;
        border: none;
        border-radius: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        transition: color 0.25s, background 0.25s;
    }
    .b-button:hover {
        background: #fff;
        color: #000 !important;
    }
`;

const NavigationMenu = ({noPadding=false}) => {
    const goToHomepage = () => window.location.replace(baseUrl);
    return (
        <MenuContainer className="HEADER">
            <InnerMenuContainer>
                <MenuFrame noPadding={noPadding}>
                    <div className="inset">
                        <FcLogoContainer src={FcLogo} onClick={goToHomepage}/>
                        <NavItems className="menu-nav">
                            <li><a href="/rankings/">Rankings</a></li>
							<li><a href="/reports/">Reports</a></li>
							<li id="teamsDropDownHover" >
								<a href="/teams/">Teams</a>
							</li>	
							<li><a href="/players/">Players</a></li>
							<li>
								<span className="a">Interactive</span>
								<ul>
									<li><a href="/rankings-builder/">Rankings Builder</a></li>
									<li><a href="/mock-draft/">Mock Draft Builder</a></li>
									<li><a href="/reports-builder/">Reports Builder</a></li>
								</ul>
							</li>
							<li>
								<span className="a">News</span>
								<ul>
									<li><a href="/news/">Articles</a></li>
									<li><a href="/podcast/">Podcast</a></li>
									<li><a href="/video/">Video</a></li>
								</ul>
							</li>
							<li>
								<span className="a">Scouts</span>
								<ul>
									<li><a href="/scouts/">Scouts</a></li>
									<li><a href="/alumni/">Alumni</a></li>
									<li><a href="/staff/">Staff</a></li>
									<li><a href="/opportunities/">Opportunities</a></li>

								</ul>
							</li>
							<li><a href="/guide/">Guide</a></li>

							<li>
								<span className="a">Partners</span>
								<ul>
									<li><a href="https://www.summerskates.ca/" target="_blank" rel="noopener noreferrer">SummerSkates</a></li>
									<li><a href="https://hockey.instatscout.com/login">InStat</a></li>
									<li><a href="https://www.crashconditioning.com/">Crash Conditioning</a></li>
									<li><a href="http://www.macleanhockey.com/">MacLean Hockey</a></li>
								</ul>
							</li>
							<li><a href="/sign-up/" className="b-button">Sign Up</a></li>
                        </NavItems>
                        <label htmlFor="toggle-nav" className="nav-trigger"></label>
                    </div>
                </MenuFrame>
            </InnerMenuContainer>
        </MenuContainer>
    );
}

export default NavigationMenu;